import script from "./HTAIGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTAIGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTAIGamePlay.vue?vue&type=style&index=0&id=1d700b4f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d700b4f"]])

export default __exports__